export default import.meta.ROLLUP_FILE_URL_zvfKnSw9ExgkfrKmfSB8CQ